/*
 * @Description: vuex 播放状态管理
 * @Author: zhangkai
 * @Date: 2020-06-15 20:18:55
 * @LastEditTime: 2020-06-21 15:30:44
 * @LastEditors: zhangkai
 */ 
import Vue from 'vue';
import Vuex from 'vuex';
import {Howl, Howler} from 'howler';

Vue.use(Vuex);

const playOption = [
    'order', // 列表播放
    'circulation', // 单曲循环
    'random' // 随机播放
];
const RateList = [0.75, 1.0, 1.25, 1.5, 2.0]; // 倍速列表

const optionList = {
    order: {
        index: 0,
        url: require('@/assets/img/home/order.png'),
        whiteUrl: require('@/assets/img/details/order.png'),
        name: '列表播放'
    },
    circulation: {
        index: 1,
        url: require('@/assets/img/home/circulation.png'),
        whiteUrl: require('@/assets/img/details/circulation.png'),
        name: '单曲循环'
    },
    random: {
        index: 2,
        url: require('@/assets/img/home/random.png'),
        whiteUrl: require('@/assets/img/details/random.png'),
        name: '随机播放'
    },
}
const store = new Vuex.Store({
    state: {
        isPlaying: false,
        isLoading: false,
        duration: 0, // 时长
        Audio: null,
        resourse: [''], // 资源文件
        playIndex: 0, // 播放下标
        rateIndex: 1, // 当前倍速下标，默认为 1.0
        playOption,
        optionList,
        playOptionIndex: 0, // 播放模式下标
    },
    actions: {
        
    },
    mutations: {
        // 设置播放状态
        SET_PLAY_STATUS(state, data) { 
            state.isPlaying = data;
        },
        SET_PLAY_OPTION_INDEX(state, index) {
            state.playOptionIndex = index
        },
        // 设置播放下标
        SET_PLAY_INDEX(state, index) {
            state.playIndex = index;
        },
        // 初始化播放器
        INIT_AUDIO(state, resourse) {
            if (state.isPlaying || state.Audio) {
                this.STOP_AUDIO(state);
            }
            state.resourse = resourse;
        },
        // 停止播放
        STOP_AUDIO(state) {
            if (state.Audio) {
                state.Audio.stop();
                state.Audio = null;
                state.isPlaying = false;
            }
        },
        // 播放
        PLAY_AUDIO(state) {
            state.isLoading = true;
            if (state.Audio) {
                // 如果正在播放，则停止重新播放
                if (state.isPlaying) {
                    state.Audio.stop();
                }
                state.Audio.play();
            }
            else {
                state.Audio = new Howl({
                    src: state.resourse[state.playIndex],
                    html5: false,
                    rate: RateList[state.rateIndex],
                    // 加载完成
                    onload: () => {
                        if (state.Audio) {
                            state.Audio.play();
                        }
                    },
                    onplay: () => {
                        state.isLoading = false;
                    },
                    // 播放结束
                    onend: () => {
                        state.isPlaying = false;
                        this.commit('ON_END');
                    }
                })
            }
            state.isPlaying = true;
        },
        // 暂停
        PAUSE_AUDIO(state) {
            if (state.Audio) {
                state.Audio.pause();
                state.isPlaying = false;
            }
        },
        // 设置播放位置
        SET_SEEK(state, timing) {
            if (state.Audio) {
                state.Audio.seek(timing);
                // this.commit('PLAY_AUDIO');
            }
        },
        // 设置加载状态
        SET_LOADING_STATUS(state, status) {
            state.isLoading = state;
        },
        // 设置倍速
        SET_RATE(state) {
            if (state.Audio) {
                if (state.rateIndex >=RateList.length - 1) {
                    state.rateIndex = -1;
                }
                state.rateIndex ++;
                state.Audio.rate(RateList[state.rateIndex]);
            }
        },
        // 播放结束
        ON_END(state) {
            const config = {
                playOption: state.playOption[state.playOptionIndex],
                switchOption: 'next'
            }
            this.commit('STOP_AUDIO');
            this.commit('SWITCH_SONG', config);
            this.commit('PLAY_AUDIO');
        },
        // 切换歌曲
        SWITCH_SONG(state, config) {
            const playOption = config.playOption; // playOption 播放模式
            const switchOption = config.switchOption; // switchOption 切换模式，next 下一曲， prev 上一曲
            // 处理播放模式
            switch(playOption) {
                case 'order': // 列表播放
                    switch(switchOption) {
                        case 'next': // 下一曲
                            if (state.playIndex < state.resourse.length - 1) {
                                state.playIndex ++;
                            }
                            else {
                                state.playIndex = 0;
                            }
                            break;
                        case 'prev': // 上一曲
                            if (state.playIndex > 0) {
                                state.playIndex --;
                            }
                            else {
                                state.playIndex = state.resourse.length - 1;
                            }
                            break;
                        default:
                            break;
                    }
                    
                    break;
                case 'circulation': // 循环播放
                    // state.playIndex = state.playIndex;
                    break;
                case 'random': // 随机播放
                    const getRandomNumber = () => {
                        const randomIndex = Math.round(Math.random() * (state.resourse.length - 1));
                        // 当前随机数相等，重新随机
                        if (state.playIndex == randomIndex) {
                            return getRandomNumber();
                        }
                        else {
                            return randomIndex;
                        }
                    }
                    state.playIndex = getRandomNumber();
                    break;
                default:
                    break;
            }
        },
    },
    getters: {
        isPlaying: state => state.isPlaying,
        isLoading: state => state.isLoading,
        gettersRate: state => RateList[state.rateIndex],
        Audio: state => state.Audio,
        playIndex: state => state.playIndex,
        playOption: state => state.playOption,
        optionList: state => state.optionList,
        playOptionIndex: state => state.playOptionIndex,
    }
})

export default store;
